import { styled } from '@linaria/react';
import { Ref, useEffect, useState } from 'react';
import { locales } from '../../locales/en';
import { registerTimer, unregisterTimer } from '../../state/state.timers';
import { InlineDotLoading } from '../presentation/InlineLoading';
import Link from '../presentation/Link';
import "./LoadingData.linaria.module.css!=!./LoadingData?./LoadingData.linaria.module.css?css=H4sIAAAAAAAAA3WS0XKDIBBF3/sfnWkecDQ1xsGvIYCGBlkH1po0k3/vCDVC0rwInHvvLgiZLkpx2nbVVSg3aHahZJKHk0JygHPzyFotI9g7D2KjN0xK4JEWef7eHKXqjhjmcRHKRoRmqRBWEY+cRCgrOSowlIMee3NPPSsv/OuBQm6ybKAG5iFtlQhLlxi+jM+1B8ZPlEuD0q7pBP6Zv0aHqr0QDgalwUV+gZcU06ozRKHs3aM0d/fyU/uE/lMB5RlT0+0t00U97bqaX5MbM2DkemN+tc44aLD0m9kP4vdvmUOiOBi3aQYmhDIdQRjothzOd3AAROhTpmWLKbH+BXnUgkHi1I+kRVZU+b4ot/UufGsr+6BP4clVeR7OMrLyszLXNZtn+9kcb9lJDkYweyHzD9k0t7dftJ0axhgDAAA="
const LoadingOuterRoot = /*#__PURE__*/styled('div')({
  name: "LoadingOuterRoot",
  class: "l14dk2g6",
  propsAsIs: false
});
const LoadingInnerRoot = /*#__PURE__*/styled('div')({
  name: "LoadingInnerRoot",
  class: "l18w5g8c",
  propsAsIs: false
});
const LoadingNote = /*#__PURE__*/styled('div')({
  name: "LoadingNote",
  class: "l1ua436n",
  propsAsIs: false
});

/**
 * TODO: Revert showReloadNotice once loading issue is fixed
 */
interface LoadingDataProps {
  ref?: Ref<HTMLDivElement>;
  noteInnerClassname?: string;
  innerRootClassName?: string;
  noteClassname?: string;
  className?: string;
  loadingStyleClassName?: string;
  showReloadNotice?: boolean;
  active?: boolean;
  note?: string;
  text?: string;
}

/**
 * TODO: Revert showReloadNotice and related state/useEffect when loading issue is fixed
 */
export const LoadingData = ({
  noteInnerClassname,
  innerRootClassName,
  noteClassname,
  className,
  loadingStyleClassName,
  text = 'LOADING...',
  showReloadNotice,
  active,
  note,
  ref
}: LoadingDataProps = {}) => {
  const [showReload, setShowReload] = useState(false);
  useEffect(() => {
    if (!showReloadNotice || showReload) return;
    registerTimer('reload', () => {
      setShowReload(true);
    }, 15000, 'timeout');
    return () => {
      unregisterTimer('reload');
    };
  }, [showReload]);
  return <LoadingOuterRoot ref={ref} className={className}>
            <LoadingInnerRoot className={innerRootClassName}>
                {!!text && <div>{text}</div>}
                {!!note && <LoadingNote className={noteClassname}>
                        <div data-testid="LoadingData__Note" className={noteInnerClassname}>
                            {note}
                        </div>
                    </LoadingNote>}
                <InlineDotLoading active={active ?? false} className={loadingStyleClassName} />
                {!!showReload && showReloadNotice && <div>
                        <br />
                        {locales.system.loadingNotice}
                        <br />
                        <Link mfc actionLink onClick={() => {
          window.location.reload();
        }}>
                            {locales.system.clickHereToReload}
                        </Link>
                    </div>}
            </LoadingInnerRoot>
        </LoadingOuterRoot>;
};